var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Flex } from "../Flex/Flex";
import { withFormWrapper } from "../withFormWrapper";
import parseChildren from "../utils/parseChildren";
import { View } from "../View/View";
import { UtilityStyle } from "../hooks/useUtilityStyles";
export var RawFieldGroup = observer(function (props) {
    var fieldChildren = parseChildren(props === null || props === void 0 ? void 0 : props.children);
    return (React.createElement(Flex, { direction: "row", gap: "small", alignItems: "stretch" }, fieldChildren.map(function (fieldChild, i) {
        return (React.createElement(FieldGroupChild, __assign({ fieldChild: fieldChild }, props, { key: i, position: i })));
    })));
});
var FieldGroupChild = function (props) {
    var fieldChild = props.fieldChild;
    var childProps = fieldChild.props;
    var renderChildComponent = useMemo(function () { return (__assign(__assign({}, fieldChild), { props: __assign(__assign({}, childProps), { ariaLabelledby: props === null || props === void 0 ? void 0 : props.describingId, labelRemoved: true, name: "".concat(props === null || props === void 0 ? void 0 : props.name, ".").concat(childProps.name), styleOptions: [UtilityStyle.BottomSpaceZero] }) })); }, [fieldChild]);
    return (React.createElement(View, { flex: (props === null || props === void 0 ? void 0 : props.childFlex) ? props === null || props === void 0 ? void 0 : props.childFlex[props === null || props === void 0 ? void 0 : props.position] : 1, position: "relative" }, renderChildComponent));
};
export var FieldGroup = withFormWrapper({
    WrappedComponent: RawFieldGroup,
    options: "objectValidation",
});
